import { useMemo, useSyncExternalStore } from 'react';

class EditingFieldStorage {
  fields: Set<string>;
  private subscribers = new Set<() => void>();

  constructor() {
    this.fields = new Set();
  }

  subscribe(callback: () => void) {
    this.subscribers.add(callback);
  }

  unsubscribe(callback: () => void) {
    this.subscribers.delete(callback);
  }

  addField(fieldName: string) {
    this.fields.add(fieldName);
  }

  removeField(fieldName: string) {
    this.fields.delete(fieldName);
  }

  clearFields() {
    this.fields.clear();
  }
}

const editingFieldStorage = new EditingFieldStorage();

export function useEditingField() {
  const subscribe = useMemo(() => {
    return (notify: () => void) => {
      editingFieldStorage.subscribe(notify);
      return () => {
        editingFieldStorage.unsubscribe(notify);
        editingFieldStorage.clearFields();
      };
    };
  }, []);

  const getFields = () => editingFieldStorage.fields;

  const data = useSyncExternalStore(subscribe, getFields);
  const handler = editingFieldStorage;

  return { data, handler };
}
